// GETTERS
export const ACCOUNT_STATEMENT_LIST = 'accountStatements/ACCOUNT_STATEMENT_LIST'
export const PARAMS_TO_SEND = 'accountStatements/PARAMS_TO_SEND'
export const COMPANY_ID = 'accountStatements/COMPANY_ID'

// MUTATIONS
export const SET_ACCOUNT_STATEMENTS = 'accountStatements/SET_ACCOUNT_STATEMENTS'
export const SET_TOTAL_ITEMS = 'accountStatements/SET_TOTAL_ITEMS'
export const SET_PAGINATION = 'accountStatements/SET_PAGINATION'
export const SET_IS_ACCOUNT_STATEMENTS_LOADING =
  'accountStatements/SET_IS_ACCOUNT_STATEMENTS_LOADING'
export const SET_FILTERS = 'accountStatements/SET_FILTERS'
export const SET_ACCOUNTS = 'accountStatements/SET_ACCOUNTS'
export const SET_IS_ACCOUNTS_LOADING =
  'accountStatements/SET_IS_ACCOUNTS_LOADING'
export const CLEAR_ACCOUNTS = 'accountStatements/CLEAR_ACCOUNTS'
export const SET_STATE = 'accountStatements/SET_STATE'

// ACTIONS
export const GET_ACCOUNT_STATEMENTS = 'accountStatements/GET_ACCOUNT_STATEMENTS'
export const GET_ACCOUNTS = 'accountStatements/GET_ACCOUNTS'
export const CHANGE_FILTERS = 'accountStatements/CHANGE_FILTERS'
export const CHANGE_PAGINATION = 'accountStatements/CHANGE_PAGINATION'
export const RESET_PAGINATION = 'accountStatements/RESET_PAGINATION'
export const RESET_STATE = 'accountStatements/RESET_STATE'
